export const ANOMALIES_LIST_REQ = 'ANOMALIES_LIST_REQ'
export const ANOMALIES_LIST_SET = 'ANOMALIES_LIST_SET'
export const ANOMALIES_LIST_SUCCESS = 'ANOMALIES_LIST_SUCCESS'
export const ANOMALIES_LIST_ERROR = 'ANOMALIES_LIST_ERROR'

export const ANOMALIES_SUMMARY_REQ = 'ANOMALIES_SUMMARY_REQ'
export const ANOMALIES_SUMMARY_SET = 'ANOMALIES_SUMMARY_SET'
export const ANOMALIES_SUMMARY_SUCCESS = 'ANOMALIES_SUMMARY_SUCCESS'
export const ANOMALIES_SUMMARY_ERROR = 'ANOMALIES_SUMMARY_ERROR'

export const ANOMALIES_DETAILS_REQ = 'ANOMALIES_DETAILS_REQ'
export const ANOMALIES_DETAILS_SUCCESS = 'ANOMALIES_DETAILS_SUCCESS'
export const ANOMALIES_DETAILS_ERROR = 'ANOMALIES_DETAILS_ERROR'

export const DISMISS_ANOMALIES_REQ = 'DISMISS_ANOMALIES_REQ'
export const DISMISS_ANOMALIES_SUCCESS = 'DISMISS_ANOMALIES_SUCCESS'
export const DISMISS_ANOMALIES_ERROR = 'DISMISS_ANOMALIES_ERROR'

export const ENABLE_ANOMALY_RULE_REQ = 'ENABLE_ANOMALY_RULE_REQ'
export const ENABLE_ANOMALY_RULE_SUCCESS = 'ENABLE_ANOMALY_RULE_SUCCESS'
export const ENABLE_ANOMALY_RULE_ERROR = 'ENABLE_ANOMALY_RULE_ERROR'


export const ANOMALIES_VIEW_PREFERENCES_REQ = 'ANOMALIES_VIEW_PREFERENCES_REQ'
export const SAVE_ANOMALIES_VIEW_PREFERENCES = 'SAVE_ANOMALIES_VIEW_PREFERENCES'

export const ANOMALIES_RULE_VIEW_PREFERENCES_REQ = 'ANOMALIES_RULE_VIEW_PREFERENCES_REQ'
export const SAVE_ANOMALIES_RULE_VIEW_PREFERENCES = 'SAVE_ANOMALIES_RULE_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/anomalies/anomalies.type.js